import style from "./DateTimeSel.module.scss";
import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import { DayPicker } from "react-day-picker";
import { Button, Collapse, IconButton, TextField } from "@mui/material";
import 'react-day-picker/dist/style.css';
import { enUS, zhCN } from 'date-fns/locale';
import { format } from 'date-fns';
import { Label, Span } from "../../../Styleds";
import styled from "styled-components";
import SelectTime from "./SelectTime";
import { updateTimeWithHrMin } from "../../comm";
// 生成 01 到 23 的小时数组
const hours = Array.from({ length: 24 }, (_, i) => (i).toString().padStart(2, '0'));
// 生成 00 到 55 的分钟数组，每隔 5 分钟
const minutes = Array.from({ length: 12 }, (_, i) => (i * 5).toString().padStart(2, '0'));

const customWeekdayFormatter = (date) => {
    const weekdays = ['週日', '週一', '週二', '週三', '週四', '週五', '週六'];
    return weekdays[date.getDay()];
};
const customMonthFormatter = (date) => {
    // 使用 date-fns 格式化函数
    return `${format(date, "yyyy 年 M 月", { locale: zhCN })} ❯`;
};

export const TimeDiv = styled.div`
                scroll-snap-align: start;
                height: ${props => props.height}px;
                min-height: ${props => props.height}px;
                max-height: ${props => props.height}px;
                display: flex;
                justify-content: center;
                align-items: center;
`;
const timeHeight = 35;
const DateTimeSel = ({ label, onSelect, dateEnabled = true, timeEnabled = true, initDate = new Date() }) => {
    const [hr, set_hr] = useState("00");
    const [min, set_min] = useState("00");
    const [selected, setSelected] = useState(initDate);
    useEffect(() => {

    }, [])
    useEffect(() => {
        if (onSelect && selected) {
            const _date = updateTimeWithHrMin(selected, hr, min);

            //console.log("selected", selected?.formatYYYYMMDD(),_date)
            onSelect(_date);
        }
    }, [hr, min, selected])
    const [expanded, setExpanded] = useState({
        startDate: false,
        startTime: false,
        endDate: false,
        endTime: false,
    });

    function openCollapse(name) {
        setExpanded(prevState => ({
            startDate: false,
            startTime: false,
            endDate: false,
            endTime: false,
            [name]: !prevState[name],
        }));
    }
    const handleSelect = (date) => {
        console.log("date",date)
        if (date) {
            setSelected(date); // 確保選取日期不會變成 undefined
        }
    };
    return (
        <>
            <div className={style.bar}>
                <Span size={17} fontWeight={0}>{label}</Span>
                <div>
                    {dateEnabled &&
                        <div className={`${style.date} ${expanded.endDate ? style.selected : ""}`}>
                            <Span size={17} fontWeight={0} onClick={e => { openCollapse("endDate") }}>{selected?.formatYYYYMMDD()}</Span>
                        </div>
                    }
                    {timeEnabled &&
                        <div className={`${style.time} ${expanded.endTime ? style.selected : ""}`}>
                            <Span size={17} fontWeight={0} onClick={e => { openCollapse("endTime") }}>{hr + ":" + min}</Span>
                        </div>
                    }
                </div>
            </div>
            <Collapse in={expanded.endDate} timeout={0} >
                <DayPicker modifiersStyles={{
                    selected: {
                        backgroundColor: '#3149CE19',
                        color: '#3149CE'
                    },
                    today: {
                        color: '#3149CE',
                        fontWeight: 'bold'
                    }
                }} mode="single" selected={selected} onSelect={handleSelect}
                    formatters={{
                        formatWeekdayName: customWeekdayFormatter,
                        formatCaption: customMonthFormatter
                    }}
                    fromDate={new Date(2024, 8, 15)}
                />
            </Collapse>
            <Collapse in={expanded.endTime} timeout={0} className={style.timePickerBox} >
                <SelectTime initHr={initDate.getHours()} initMin={initDate.getMinutes()} onChangedHr={value => {
                    set_hr(value);
                }} onChangedMin={value => {
                    set_min(value);
                }} />
            </Collapse>
        </>
    );
}
export default DateTimeSel;